


























import { Component, Prop, Vue } from 'vue-property-decorator'
import { CardColorEnum } from '~/enums/card/CardColorEnum'

@Component
export default class Card extends Vue {
  @Prop({
    type: String,
    required: false
  })
  title: string

  @Prop({
    type: Boolean,
    default: false,
    required: false
  })
  verticalPadding: boolean

  @Prop({
    type: String,
    required: false
  })
  color: CardColorEnum
}
